import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {ConfigProvider} from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import {AxiosInterceptor} from "./lib/axiosInterceptor";

dayjs.locale('zh-cn');

ReactDOM.render((
    <BrowserRouter>
        <ConfigProvider locale={zhCN}>
            <AxiosInterceptor>
                <App/>
            </AxiosInterceptor>
        </ConfigProvider>
    </BrowserRouter>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
